import { render } from "./SlotSkeleton.vue?vue&type=template&id=f9f8a73a&ts=true"
import script from "./SlotSkeleton.vue?vue&type=script&lang=ts"
export * from "./SlotSkeleton.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__